import React from "react";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Link as RouterLink } from "react-router-dom";
import Banner from "../components/Banner";
import LegalLinks from "../components/LegalLinks";

export default function PromptHelp() {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: (theme) => (theme.palette.mode === "light" ? "#f4f6f7" : theme.palette.background.default) }}>
      <Banner />

      <Container maxWidth="lg" sx={{ pt: 10, pb: 8 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h4" component="h1" fontWeight="bold">
            Prompt Help
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.5, md: 4 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            backgroundColor: "rgba(255, 255, 255, 0.97)",
            color: "#0f172a",
          }}
        >
          <Typography sx={{ color: "#475467", mb: 2.5 }}>
            T-accounts.com is the modern way to create and manage t-accounts for analyzing journal entries, accounting education, and journal entry support.
            Use the prompt box to create and update t-account entries quickly with short commands.
          </Typography>

          <Stack spacing={1.2} sx={{ mb: 3 }}>
            <Typography>
              1. Type a command (for example: <Box component="span" sx={{ fontFamily: "Consolas, Monaco, 'Courier New', monospace" }}>debit Cash 200</Box>).
            </Typography>
            <Typography>
              2. Use TAB to accept autocomplete suggestions.
            </Typography>
            <Typography>
              3. Use the autocomplete toggle button to turn suggestions on or off.
            </Typography>
            <Typography>
              4. Press [Enter] to submit your command to create or update journal entry lines.
            </Typography>
            <Typography>
              5. Use undo and redo controls to quickly recover from mistakes.
            </Typography>
            <Typography>
              6. Print your document to PDF, PNG, or a .xlsx spreadsheet.
            </Typography>
            <Typography>
              7. Use the settings button to tailor T-accounts.com to your needs.
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  verticalAlign: "middle",
                  ml: 0.75,
                  border: "1px solid #1976d2",
                  borderRadius: "6px",
                  color: "#1976d2",
                  p: "4px",
                  lineHeight: 0,
                }}
              >
                <SettingsOutlinedIcon sx={{ fontSize: 16 }} />
              </Box>
            </Typography>
          </Stack>

          <Typography sx={{ color: "#475467", mb: 2 }}>
            Need the full command reference with examples?
          </Typography>

          <Button
            component={RouterLink}
            to="/prompt-commands"
            variant="contained"
            sx={{ textTransform: "none", mb: 3 }}
          >
            Open Prompt Commands
          </Button>

          <Typography sx={{ color: "#667085", mt: 1.2 }}>
            If you have questions or need additional support, plesae email support@t-accounts.com. Please feel free to send us feedback by clicking on the Feedback button at the top of the page.
          </Typography>

          <Box sx={{ mt: 4, pt: 2, borderTop: "1px solid", borderColor: "divider", color: "#667085" }}>
            <LegalLinks centered />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}